// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-small);
}

:host(.action-on-right) {
  flex-direction: row-reverse;
}

.comment-field-wrapper {
  background-color: var(--color-blue);
  border-radius: var(--border-radius-medium);
  flex: 1;
}

:host-context(.dark-theme) .comment-field-wrapper {
  background-color: var(--color-white);
}

.comment-field {
  margin: 0;
  --mdc-outlined-text-field-outline-width: 0;
  width: 100%;
}

.comment-input {
  text-align-last: center;
  overflow: hidden;
  --mat-form-field-container-vertical-padding: 0;
  --mdc-outlined-text-field-input-text-color: var(--color-white);
  --mdc-outlined-text-field-caret-color: var(--color-white);
}

:host-context(.dark-theme) .comment-input {
  --mdc-outlined-text-field-input-text-color: var(--color-blue);
  --mdc-outlined-text-field-caret-color: var(--color-blue);
}

::ng-deep .mdc-text-field--outlined .mat-mdc-form-field-infix, .mdc-text-field--no-label .mat-mdc-form-field-infix {
  --mat-form-field-container-vertical-padding: 20px;
}

.action-wrapper {
  flex: 0 0 auto;
  min-width: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/patient/components/comment/comment.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,mCAAA;EACA,0CAAA;EACA,OAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,SAAA;EACA,0CAAA;EACA,WAAA;AACF;;AAEA;EACE,uBAAA;EACA,gBAAA;EACA,8CAAA;EACA,8DAAA;EACA,yDAAA;AACF;;AAEA;EACE,6DAAA;EACA,wDAAA;AACF;;AAEA;EACE,iDAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-small)\n}\n\n:host(.action-on-right) {\n  flex-direction: row-reverse;\n}\n\n.comment-field-wrapper {\n  background-color: var(--color-blue);\n  border-radius: var(--border-radius-medium);\n  flex: 1;\n}\n\n:host-context(.dark-theme) .comment-field-wrapper {\n  background-color: var(--color-white);\n}\n\n.comment-field {\n  margin: 0;\n  --mdc-outlined-text-field-outline-width: 0;\n  width: 100%;\n}\n\n.comment-input {\n  text-align-last: center;\n  overflow: hidden;\n  --mat-form-field-container-vertical-padding: 0;\n  --mdc-outlined-text-field-input-text-color: var(--color-white);\n  --mdc-outlined-text-field-caret-color: var(--color-white);\n}\n\n:host-context(.dark-theme) .comment-input {\n  --mdc-outlined-text-field-input-text-color: var(--color-blue);\n  --mdc-outlined-text-field-caret-color: var(--color-blue);\n}\n\n::ng-deep .mdc-text-field--outlined .mat-mdc-form-field-infix, .mdc-text-field--no-label .mat-mdc-form-field-infix {\n  --mat-form-field-container-vertical-padding: 20px;\n}\n\n.action-wrapper {\n  flex: 0 0 auto;\n  min-width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
